import React from 'react';

const ClientSwitchWarningModal = ({ 
  isOpen, 
  clientName, 
  activeUsers,  // array of { name, lastActiveAt }
  onProceed, 
  onCancel 
}) => {
  if (!isOpen) return null;

  const formatTime = (dateStr) => {
    const diff = Math.floor(
      (Date.now() - new Date(dateStr)) / 1000 / 60
    );
    if (diff < 1) return 'just now';
    if (diff < 60) return `${diff} min ago`;
    return `${Math.floor(diff / 60)}h ago`;
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center 
                    justify-center bg-black bg-opacity-40">
      <div className="bg-white rounded-lg shadow-xl w-full 
                      max-w-md mx-4 p-6">
        
        {/* Header */}
        <div className="flex items-start gap-3 mb-4">
          <div className="flex-shrink-0 w-10 h-10 rounded-full 
                          bg-amber-100 flex items-center 
                          justify-center">
            <svg className="w-5 h-5 text-amber-600" 
                 fill="none" viewBox="0 0 24 24" 
                 stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" 
                    strokeWidth={2} 
                    d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 
                       0 2.502-1.667 1.732-3L13.732 4c-.77-1.333
                       -2.694-1.333-3.464 0L3.34 16c-.77 
                       1.333.192 3 1.732 3z" />
            </svg>
          </div>
          <div>
            <h3 className="text-base font-semibold text-gray-900">
              Client Currently In Use
            </h3>
            <p className="text-sm text-gray-500 mt-0.5">
              {clientName}
            </p>
          </div>
        </div>

        {/* Active users list */}
        <div className="bg-amber-50 border border-amber-200 
                        rounded-md p-3 mb-5">
          <p className="text-xs font-medium text-amber-800 
                        uppercase tracking-wide mb-2">
            Currently active
          </p>
          <div className="space-y-2">
            {activeUsers.map((u, i) => (
              <div key={i} 
                   className="flex items-center 
                              justify-between">
                <div className="flex items-center gap-2">
                  <div className="w-6 h-6 rounded-full 
                                  bg-amber-300 flex items-center 
                                  justify-center text-xs 
                                  font-semibold text-amber-900">
                    {u.name.charAt(0).toUpperCase()}
                  </div>
                  <span className="text-sm font-medium 
                                   text-gray-800">
                    {u.name}
                  </span>
                </div>
                <span className="text-xs text-gray-500">
                  Active {formatTime(u.lastActiveAt)}
                </span>
              </div>
            ))}
          </div>
        </div>

        {/* Message */}
        <p className="text-sm text-gray-600 mb-5">
          You can still switch to this client, but please 
          coordinate with{' '}
          {activeUsers.length === 1 
            ? activeUsers[0].name 
            : 'the other users'}{' '}
          to avoid duplicate or conflicting entries.
        </p>

        {/* Actions */}
        <div className="flex gap-3 justify-end">
          <button
            onClick={onCancel}
            className="px-4 py-2 text-sm font-medium 
                       text-gray-700 bg-white border 
                       border-gray-300 rounded-md 
                       hover:bg-gray-50 transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={onProceed}
            className="px-4 py-2 text-sm font-medium 
                       text-white bg-amber-600 rounded-md 
                       hover:bg-amber-700 transition-colors"
          >
            Proceed Anyway
          </button>
        </div>
      </div>
    </div>
  );
};

export default ClientSwitchWarningModal;
